import {ActivityModel, ParticipantActivityModel, PointsCollectedModel} from '../../models';

export default {
    namespaced: true,
    state: {
        currentQuests: null,
        pointsMessages: null,
        upcomingQuests: null,
        newParticipants: null,
    },
    mutations: {
        setCurrentQuests(state, val) {
            state.currentQuests = val;
        },
        setPointsMessages(state, val) {
            state.pointsMessages = val;
        },
        setUpcomingQuests(state, val) {
            state.upcomingQuests = val;
        },
        setNewParticipants(state, val) {
            state.newParticipants = val;
        },
    },
    actions: {
        refreshPointsList({commit}) {
            return PointsCollectedModel.loadNewPointsCollected().then(result => {
                commit('setPointsMessages', result.data);
            });
        },
        loadData({commit}, options) {
            return Promise.allSettled([
                ActivityModel.loadCurrentDashboardQuests(),
                ParticipantActivityModel.loadNewParticipants(),
                PointsCollectedModel.loadNewPointsCollected(),
                ActivityModel.loadUpcomingQuests(),
            ]).then(([currentQuests, newParticipants, pointsMessages, upcomingQuests]) => {
                if (!options || !options.deferredCommit) {
                    commit('setCurrentQuests', currentQuests.value);
                    commit('setNewParticipants', newParticipants.value.data);
                    commit('setPointsMessages', pointsMessages.value.data);
                    commit('setUpcomingQuests', upcomingQuests.value);
                } else {
                    return () => {
                        commit('setCurrentQuests', currentQuests.value);
                        commit('setNewParticipants', newParticipants.value.data);
                        commit('setPointsMessages', pointsMessages.value.data);
                        commit('setUpcomingQuests', upcomingQuests.value);
                    };
                }
            });
        },
        loadAddedQuest({commit}) {
            ActivityModel.loadCurrentDashboardQuests().then(quests => {
                commit('setCurrentQuests', quests);
            });
            ActivityModel.loadUpcomingQuests().then(result => {
                commit('setUpcomingQuests', result);
            });
        },
    },
};
